"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureSession = void 0;
/* eslint-disable complexity */
const base_1 = require("../../../security/session/base");
const storage_1 = require("../../../security/session/storage");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class AzureSession extends base_1.BaseSession {
    constructor(store) {
        super(new storage_1.SessionStorage(store));
        this.isDataValid = (sessionData) => {
            var _a, _b, _c;
            if (((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken) === null || _a === void 0 ? void 0 : _a.trim()) !== '' && ((_b = sessionData === null || sessionData === void 0 ? void 0 : sessionData.refreshToken) === null || _b === void 0 ? void 0 : _b.trim()) !== '' && ((_c = sessionData === null || sessionData === void 0 ? void 0 : sessionData.username) === null || _c === void 0 ? void 0 : _c.trim()) !== '') {
                return true;
            }
            return false;
        };
    }
}
exports.AzureSession = AzureSession;
//# sourceMappingURL=index.js.map